// extracted by mini-css-extract-plugin
export default {"articleListingHeader":"components_articleListingHeader__etz42","pagedArticles":"components_pagedArticles__TyfZp","categoryListingLinks":"components_categoryListingLinks__fiIEj"};